import ons from "onsenui";

interface SimpleAlertOptions {
  title?: string;
  message?: string;
  icon?: "warning" | "error" | "success";
  callback?: (buttonIndex?: number) => void;
  buttonLabel?: string | undefined | string[];
  cancelable?: boolean;
  className?: string;
}

interface AlertOptions {
  message?: string;
  messageHTML?: string;
  buttonLabel?: string;
  buttonLabels?: [string];
  primaryButtonIndex?: number;
  cancelable?: boolean;
  animation?: string;
  title?: string;
  modifier?: string;
  callback?: any;
  id?: string;
}

export function simpleAlert(options: SimpleAlertOptions): Promise<number | undefined> {
  return new Promise<number | undefined>((resolve) => {
    const params: AlertOptions = {
      callback: (result: number | undefined) => {
        resolve(result);
        if (options.callback !== undefined) {
          options.callback(result);
        }
      },
      animation: "none",
      modifier: "material " + options.icon,
      title: options.title !== "" ? options.title : "",
      messageHTML: `<div class="video-alert ${options.className}">${options.message}</div>`,
      buttonLabel:
        options.buttonLabel !== undefined
          ? typeof options.buttonLabel === "object"
            ? undefined
            : options.buttonLabel
          : "OK",
      buttonLabels:
        options.buttonLabel !== undefined
          ? typeof options.buttonLabel === "object"
            ? (options.buttonLabel as [string])
            : undefined
          : ["OK"],
      cancelable: options.cancelable !== undefined ? options.cancelable : true,
    };

    ons.notification.alert(params);
  });
}
